import { render, staticRenderFns } from "./TagihanAgen.vue?vue&type=template&id=66fb5073"
import script from "./TagihanAgen.vue?vue&type=script&lang=js"
export * from "./TagihanAgen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports